import { ErrorHandler } from '@/helpers/errorHandler';
import SentryClient from '@/helpers/sentry';
import {
  WESTEROS_AUTHORIZATION_ENUM,
  WESTEROS_MICROSERVICES_ENUM,
  westerosMutation,
  westerosQuery,
} from '@/helpers/westeros';
import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import { MicrocertificateState } from './state';
import { getUserMicrocertificates } from '@/store/queries/westerosQueries';
import { setUserMicrocertificatePdfMutation } from '@/store/mutations/westerosMutations';

const SET_MICROCERTIFICATES = 'SET_MICROCERTIFICATES';
const SET_GENERATING_MICROCERTIFICATE = 'SET_GENERATING_MICROCERTIFICATE';

const actions: ActionTree<MicrocertificateState, RootState> = {
  async GET_USER_MICROCERTIFICATES({ commit }): Promise<void> {
    try {
      const { data } = await westerosQuery(
        WESTEROS_MICROSERVICES_ENUM.MICROCERTIFICATES,
        getUserMicrocertificates,
        {},
        WESTEROS_AUTHORIZATION_ENUM.PROFILE,
      );

      if (!data?.getUserMicrocertificates) {
        ErrorHandler.showErrorMessage({
          error: new Error('No data returned from getUserMicrocertificates query'),
          defaultMessage: true,
        });
        return;
      }

      const microcertificates = data.getUserMicrocertificates;
      commit(SET_MICROCERTIFICATES, microcertificates);
    } catch (e) {
      SentryClient.captureError(e);
    }
  },
  async GENERATE_MICROCERTIFICATE({ commit }, payload): Promise<Object> {
    const { id } = payload;

    commit(SET_GENERATING_MICROCERTIFICATE, true);

    const response = await westerosMutation(
      WESTEROS_MICROSERVICES_ENUM.MICROCERTIFICATES,
      setUserMicrocertificatePdfMutation,
      { microcertificateId: id },
      WESTEROS_AUTHORIZATION_ENUM.DEX,
    );

    if (
      !response ||
      !response.data ||
      !response.data.setUserMicrocertificatePdfMutation ||
      !response.data.setUserMicrocertificatePdfMutation.success
    ) {
      throw new Error('Open pdf Microcertificates failed');
    }
    const pdf = response.data.setUserMicrocertificatePdfMutation;

    window.open(pdf.url, '_blank');

    commit(SET_GENERATING_MICROCERTIFICATE, false);

    return pdf;
  },
};

export default actions;
